// src/services/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Your Firebase configuration
// Replace these values with your actual Firebase project settings
const firebaseConfig = {
  apiKey: "AIzaSyCeBTkI_XP09eHlTAvo4H2jL7FdhSKKYgc",
  authDomain: "parked-flutter.firebaseapp.com",
  databaseURL: "https://parked-flutter-default-rtdb.firebaseio.com",
  projectId: "parked-flutter",
  storageBucket: "parked-flutter.appspot.com",
  messagingSenderId: "378485831069",
  appId: "1:378485831069:web:ffe9fd0c8246915d262b74",
  measurementId: "G-SS4NZZ2X12"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };